import React from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../store/types';
import { REDUX_STORE_SLICES } from '../../../../services/exports/Constants';
import collect from 'collect.js';

const FranchiseLogo = () => {
  const { franchise } = useSelector((store: StoreInterface) => store[REDUX_STORE_SLICES.INITIAL_DATA]);
  const franchiseLogoUrl = collect(franchise?.logos).last()?.url;

  if (!franchiseLogoUrl) {
    return;
  }

  return (
    <div className="absolute left-0 rounded-xl overflow-hidden">
      <img alt="Logo" src={franchiseLogoUrl} className="h-6 bg-white " />
    </div>
  );
};

export default FranchiseLogo;
